import React from "react";
import styles from "./RelationTotals.module.scss";
import Skeleton from "@/components/Skeleton/Skeleton";

function RelationsTotals({
  title,
  isLoading,
  count,
}: {
  title: string;
  isLoading: boolean;
  count: number | undefined;
}) {
  return (
    <div className={styles.relation}>
      <div>
        <h3>{title}</h3>
        <span className={styles.metric}>
          <Skeleton
            loading={isLoading}
            style={{ width: 20, height: 24 }}
          >
            {count}
          </Skeleton>
        </span>
      </div>
    </div>
  );
}

export default RelationsTotals;
